import { render } from "./AposCellLabels.vue?vue&type=template&id=99dcb742&scoped=true"
import script from "./AposCellLabels.vue?vue&type=script&lang=js"
export * from "./AposCellLabels.vue?vue&type=script&lang=js"

import "./AposCellLabels.vue?vue&type=style&index=0&id=99dcb742&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99dcb742"],['__file',"ui/ui/apos/components/AposCellLabels.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "99dcb742"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('99dcb742', __exports__)) {
    api.reload('99dcb742', __exports__)
  }
  
  module.hot.accept("./AposCellLabels.vue?vue&type=template&id=99dcb742&scoped=true", () => {
    api.rerender('99dcb742', render)
  })

}


export default __exports__